<template>
  <div class="content-container">
    <NotAvailable v-if="isNotAvailable" is-not-existed />

    <WaiverContainer
      v-else
      :mode="mode"
      :standalone-link-uuid="standaloneLinkUuid"
      :company-shortname="companyShortname"
      :booking-uuid="bookingUuid"
      :set-is-not-available="setIsNotAvailable"
      :is-dock-device="isDockDevice"
    />
  </div>
  <FooterLayout />
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import WaiverContainer from './WaiverContainer.vue';
import FooterLayout from './FooterLayout.vue';
import NotAvailable from './waiver-statuses/NotAvailable.vue';
import { addSuperProperty } from '../scripts/mixpanel';
import { WAIVER_MODE } from '../constants/waiverModes';

const params = new Proxy(new URLSearchParams(window.location.search), {
  get: (searchParams, prop) => searchParams.get(prop),
});

// Anonymous standalone flow is served at /waivers/link/<uuid>/ and is keyed
// solely by the public link uuid (no company shortname / booking).
const STANDALONE_PATH_RE =
  /\/waivers\/link\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\/?$/i;
const standaloneMatch = window.location.pathname.match(STANDALONE_PATH_RE);
const standaloneLinkUuid = standaloneMatch ? standaloneMatch[1] : '';

const companyShortname = params.shortname;
const { bookingUuid, source } = params;

const mode = standaloneLinkUuid ? WAIVER_MODE.STANDALONE : WAIVER_MODE.BOOKING;

const isNotAvailable = ref(
  mode === WAIVER_MODE.STANDALONE
    ? !standaloneLinkUuid
    : !(companyShortname && bookingUuid),
);
const isDockDevice = computed(() => !!source?.match(/^fhdock-/));

const setIsNotAvailable = () => {
  isNotAvailable.value = true;
};

onMounted(() => {
  const mxData = {
    'fh-waiver-form-source': source || 'direct-link',
  };

  if (companyShortname) {
    mxData['current-company'] = companyShortname;
  }

  if (bookingUuid) {
    mxData.booking = bookingUuid;
  }

  if (standaloneLinkUuid) {
    mxData['fh-waiver-standalone-link'] = standaloneLinkUuid;
  }

  addSuperProperty(mxData);
});
</script>

<style scoped>
.content-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: var(--fh-size-4xl);
  /* 88px is the sum of padding-top(40px) and the footer panel size(48px) */
  min-height: calc(100vh - 88px);
}

@media only screen and (max-width: 679px) {
  .content-container {
    padding-top: 0;
    /* 48px is the footer panel size(48px) */
    min-height: calc(100vh - 48px);
  }
}
</style>
